import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { CartScopeEq } from '@/models/cart/group/scope'
import BundleDiscountService from '@/services/api/bundle-discount'
import CartFreeAreaService from '@/services/free-area/cart/cart-free-area'
import FreeAreaService from '@/services/free-area/free-area'
import { NoveltyService } from '@/services/novelty'
import AppId from '@/util/appid'
import { CartService } from '@spa/services/api/cart'

export interface CartServiceLocator {
  readonly cartService: CartService
  readonly freeAreaService: FreeAreaService
  readonly noveltyService: NoveltyService
  readonly bundleDiscountService: BundleDiscountService
}

export const createForBrand = (brandName: string): CartServiceLocator => {
  const appId = AppId.getByBrandName(brandName)
  const behavior = BehaviorConfig.createFromBrand(brandName)

  return {
    cartService: new CartService(appId),
    freeAreaService: FreeAreaService.createFromBrandName(brandName, CartFreeAreaService.forBrand),
    noveltyService: new NoveltyService(appId, behavior),
    bundleDiscountService: new BundleDiscountService(appId),
  }
}

export const forHost: CartServiceLocator = {
  cartService: new CartService(),
  freeAreaService: FreeAreaService.createForHost(CartFreeAreaService.forHost),
  noveltyService: new NoveltyService(AppId.getHostId(), new BehaviorConfig()),
  bundleDiscountService: new BundleDiscountService(),
}

export const selectLocatorByScope = (scope: CartScopeEq) => {
  switch (scope.kind.toString()) {
    case 'brand':
      return createForBrand(scope.value.toString())
    default:
      return forHost
  }
}
